import React, { useState } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { SET_SELECTED_FILTER } from 'estimate_list/reducers/initial'
import Alink from 'estimate_list/libs/alink'
import { filterTheorem } from 'estimate_list/libs/util'

const ItemBrandView = ({ data }) => {
    // makerInfo.maker_url - 1 : 네이버 블로그, 11 : 홈페이지, 12 : 고객지원, 13 : 자료실, 21 : 페이스북
    const { makerInfo } = data
    const selectedFilters = useSelector(state => state.initial.selectedFilters)
    const { maker } = selectedFilters
    const [view, setView] = useState(false)

    const dispatch = useDispatch()

    const isMaker = maker_id => {
        const index = maker.findIndex(v => v.maker_id === maker_id)
        return index > -1
    }

    const onClickBrand = (maker_id, maker_name) => () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'brand',
                value: { maker_id, maker_name }
            })
        })
    }

    return (
        <Style>
            <button type="button" className="btn_items_view" onClick={onClickBrand(data.maker_id, data.maker_name)}>
                <span className="brand_conts_logo">{data.maker_name}</span>
                {isMaker(data.maker_id)
                    ? <b className="highlight">선택값 해제 <i className="icon-triangle-right" /></b>
                    : <b>상품만 보기 <i className="icon-triangle-right" /></b>
                }
            </button>
            {makerInfo.maker_url && (
                <div className="brand_conts_info">
                    {makerInfo.maker_url['1'] && (
                        <Alink href={makerInfo.maker_url['1']} className="btn">
                            <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/icon_naver_mini.png`} alt="naver" />
                        </Alink>
                    )}
                    {makerInfo.maker_url['21'] && (
                        <Alink href={makerInfo.maker_url['21']} className="btn">
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/icon_facebook_mini.png`}
                                alt="facebook"
                            />
                        </Alink>
                    )}
                    {makerInfo.maker_url['22'] && (
                        <Alink href={makerInfo.maker_url['22']} className="btn">
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/icon_instagram_mini.png`}
                                alt="facebook"
                            />
                        </Alink>
                    )}
                    {(makerInfo.maker_url['11'] || makerInfo.maker_url['12'] || makerInfo.maker_url['13']) &&
                        <div className="brand_conts_info_menu">
                            <button type="button" className="btn_info" onClick={() => setView(state => !state)}>
                                <img
                                    src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/icon_info_mini.png`}
                                    alt="추가정보"
                                />
                            </button>
                            {view && (
                                <div className="brand_conts_info_menu_layer">
                                    <ul>
                                        {makerInfo.maker_url['11'] && (
                                            <li>
                                                <Alink href={makerInfo.maker_url['11']} target="_blank">
                                                    <span>홈페이지</span>
                                                </Alink>
                                            </li>
                                        )}
                                        {makerInfo.maker_url['12'] && (
                                            <li>
                                                <Alink href={makerInfo.maker_url['12']} target="_blank">
                                                    <span>고객센터</span>
                                                </Alink>
                                            </li>
                                        )}
                                        {makerInfo.maker_url['13'] && (
                                            <li>
                                                <Alink href={makerInfo.maker_url['13']} target="_blank">
                                                    <span>자료실</span>
                                                </Alink>
                                            </li>
                                        )}
                                    </ul>
                                    <button type="button" className="btn_closed" onClick={() => setView(false)}>
                                        <i className="icon-close" />
                                    </button>
                                </div>
                            )}
                        </div>
                    }
                </div>
            )}
        </Style>
    )
}

const Style = styled.div`
    &:after {
        content:'';
        display: block;
        clear: both;
    }
    .brand_conts_logo {
        margin-right: 5px;
    }
    .highlight {
        color: #418ded
    }
    .btn_items_view {
        position: relative;
        float: left;
        margin: 0 12px 0 0;
        height: 22px;
        border: 0;
        color: #333;
        vertical-align: middle;
        letter-spacing: 0;
        font-weight: 700;
        cursor: pointer;

        &:hover {
            text-decoration: underline
        }
        i {
            position: absolute;
            right: -12px;
            top: 5px;
        }
    }
    .brand_conts_info {
        float: left;
        margin-left: 5px;
        padding-top: 3px;

        .brand_conts_info_menu {
            position: relative;
            float: left;
        }
        .brand_conts_info_menu_layer {
            position: absolute;
            left: 20px;
            top: 50%;
            margin-top: -36px;
            padding: 4px 30px 4px 8px;
            border: 2px solid #418ded;
            background: #fff;
            z-index: 2;

            li {
                line-height: 20px;
                white-space: nowrap;
            }
            .btn_closed {
                position: absolute;
                right: 0;
                top: 0;
                width: 24px;
                height: 24px;
                border: 0;
                color: #333;
                vertical-align: middle;
                letter-spacing: 0;
                cursor: pointer;
                box-sizing: border-box;
            }
        }
        .btn {
            float: left;
            margin-right: 2px;
        }
    }
`

export default ItemBrandView



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item_brand_view.js